module.exports = __webpack_public_path__ + "img/etc-cz.d274a283.png";